import React from 'react'
import { ParsedOpeningHour } from '../../helpers/parse-opening-hours/types'
import { Text } from '@hub/text'
import { Stack } from '@hub/stack'
import { Box } from '@hub/box'
import { HubStyleObject } from '@hub/design-system-base'

export interface TradingHoursLineProps {
  openHourDay: ParsedOpeningHour
  sx?: HubStyleObject
  daySx?: HubStyleObject
  hoursSx?: HubStyleObject
}

function hasNoHours(openHourDay: ParsedOpeningHour): boolean {
  return !openHourDay || !openHourDay.day || !openHourDay.hours
}

function hasNoDescription(text: ParsedOpeningHour['text']): boolean {
  return !text || !text.description
}

const DescriptionText = ({
  text,
}: {
  text: ParsedOpeningHour['text']
}): JSX.Element | null =>
  hasNoDescription(text) ? null : (
    <Text
      sx={{
        marginTop: 'spacing-xs',
      }}
    >
      {text.description}
    </Text>
  )

const TradingHoursLine: React.FC<
  React.PropsWithChildren<TradingHoursLineProps>
> = ({ openHourDay, sx, daySx, hoursSx }): JSX.Element | null => {
  if (hasNoHours(openHourDay)) {
    return null
  }
  const { hours, day, text } = openHourDay
  return (
    <Stack>
      <Box
        data-test-id="opening-hours-entry"
        sx={{
          display: 'flex',
          fontWeight: day === 'Today' ? 'medium' : 'normal',
          ...sx,
        }}
      >
        {/* day */}
        <Text sx={{ width: 'size-13', ...daySx }}>{day}</Text>

        {/* hours */}
        <Box sx={hoursSx}>
          {hours.length > 1 ? (
            <span>
              {hours.map((hour: string) => (
                <Text key={hour}>{hour}</Text>
              ))}
            </span>
          ) : (
            <Text>{hours}</Text>
          )}
        </Box>
      </Box>
      <DescriptionText text={text} />
    </Stack>
  )
}

export default TradingHoursLine
